const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => req.keys().map(requireContext)
requireAll(req)
